export const NONE = 'none'
export const GRADIENT = 'gradient'
export const SOLID = 'solid'
